import { useRequiredContext } from "@redotech/react-util/context";
import { useRpcData } from "@redotech/react-util/rpc-data";
import type { GradeMapping } from "@redotech/redo-return-settings-common/grade-mapping";
import { RedoManagedReturnsRpcClientContext } from "./rpc-client";

/** Saved grade mappings from CRDB; `undefined` until loaded so editors never start from the stale team copy. */
export function useGradeMappings(): {
  gradeMappings: readonly GradeMapping[] | undefined;
  refresh: () => void;
} {
  const rpcClient = useRequiredContext(RedoManagedReturnsRpcClientContext);
  const { value, refresh } = useRpcData(rpcClient, "getGradeMappings", {
    input: {},
  });
  return { gradeMappings: value?.gradeMappings, refresh };
}
